import { v4 as uuidv4 } from 'uuid';
import { POINTS_SOURCE, POINTS_CIRCLE_LAYER } from './constants';
import { LocationType } from '../Sidebar/LocationList';
import { safeSetSourceData } from './utils';

// Update location point data
export const updateLocations = ({
  map,
  mapReady,
  sourcesReady,
  locations,
  startId
}) => {
  if (!map || !mapReady || !sourcesReady) return;
  
  try {
    // Convert location data to GeoJSON format
    const pointFeatures = locations.map(location => ({
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [location.longitude, location.latitude]
      },
      properties: {
        id: location.id,
        name: location.name,
        latitude: location.latitude,
        longitude: location.longitude,
        type: location.type || LocationType.NORMAL,
        tpType: location.tpType,  // Add TP type for color determination
        isStart: false,  // TP module doesn't use start point concept
        number: location.number || location.name  // Use CSV number or fallback to name
      }
    }));
    
    // Create GeoJSON data structure
    const data = {
      type: 'FeatureCollection',
      features: pointFeatures
    };
    
    // Update point data source
    safeSetSourceData(map, mapReady, sourcesReady, POINTS_SOURCE, data);
  } catch (err) {
    console.error("Error updating location point data:", err);
  }
};

// Handle map click to add new point
export const handleMapClick = (e, {
  currentMode,
  locations,
  setLocations
}) => {
  // TP module does not support map clicking to add points
  // Only CSV upload is supported for adding locations
  return;
};

// Handle clicking on existing marker points
export const handleSelectPoint = (e, {
  currentMode,
  locations,
  onMapPointSelect
}) => {
  if (!e.features || e.features.length === 0) return;
  if (currentMode !== 'Custom Path' || !onMapPointSelect) return;
  
  const clickedFeature = e.features[0];
  const pointId = clickedFeature.properties.id;
  
  // Find corresponding location point object
  const selectedPoint = locations.find(loc => loc.id === pointId);
  if (selectedPoint) {
    // Call callback function to pass selected point to CustomMode component
    onMapPointSelect(selectedPoint);
  }
};

// Setup marker hover events
export const setupMarkerHoverEvents = (map, popupRef) => {
  if (!map) return;
  
  // Only change cursor when hovering over points, no popup
  map.on('mouseenter', POINTS_CIRCLE_LAYER, () => {
    map.getCanvas().style.cursor = 'pointer';
  });
  
  // Reset cursor when mouse leaves point
  map.on('mouseleave', POINTS_CIRCLE_LAYER, () => {
    map.getCanvas().style.cursor = '';
  });
}; 